// extracted by mini-css-extract-plugin
export default {"alert":"OrderClarifications_alert__6bprz","clarification":"OrderClarifications_clarification__BiZ4T"};